import React from "react";
import { useTranslation } from "react-i18next";

const END = new Date("2026-08-22T00:00:00+09:00");
const IMG = "/imid-2026-booth-21.jpg";
const LINK = "/research-highlights/imid-2026-booth-21.html";
const BOOK = "https://cal.com/yogeshgawale";

const T = {
  en: { head: "Upcoming events", name: "IMID 2026", tag: "The 26th International Meeting on Information Display", date: "August 18 to 21, 2026", place: "BEXCO, Busan, Republic of Korea", booth: "Booth 21",
        blurb: "Meet the LUMORA team at Booth 21. We will show our OLED and MR-TADF emitter portfolio, high-purity hosts and transport materials, and discuss custom synthesis and scale-up for your programs.",
        book: "Book a meeting slot", read: "Read the invitation" },
  ko: { head: "예정된 행사", name: "IMID 2026", tag: "제26회 국제정보디스플레이학술대회", date: "2026년 8월 18일 ~ 21일", place: "부산 벡스코, 대한민국", booth: "부스 21",
        blurb: "부스 21에서 LUMORA 팀을 만나보세요. OLED 및 MR-TADF 발광 재료 포트폴리오, 고순도 호스트 및 수송층 소재를 소개하고, 맞춤 합성과 스케일업에 대해 상담해 드립니다.",
        book: "미팅 예약하기", read: "초대장 보기" },
  zh: { head: "近期活动", name: "IMID 2026", tag: "第26届国际信息显示大会", date: "2026年8月18日至21日", place: "韩国釜山 BEXCO", booth: "展位 21",
        blurb: "欢迎在 19 号展位与 LUMORA 团队会面。我们将展示 OLED 与 MR-TADF 发光材料、高纯主体与传输材料，并就定制合成与放大生产进行交流。",
        book: "预约会面", read: "查看邀请函" },
  de: { head: "Kommende Veranstaltungen", name: "IMID 2026", tag: "26. International Meeting on Information Display", date: "18. bis 21. August 2026", place: "BEXCO, Busan, Republik Korea", booth: "Stand 21",
        blurb: "Treffen Sie das LUMORA Team an Stand 21. Wir zeigen unser Portfolio an OLED und MR-TADF Emittern, hochreinen Hosts und Transportmaterialien und besprechen kundenspezifische Synthese und Scale-up.",
        book: "Termin buchen", read: "Einladung lesen" },
};

export const UpcomingEvents = ({ compact }) => {
  const { i18n } = useTranslation();
  const lang = ((i18n && i18n.language) || "en").slice(0, 2);
  if (new Date() >= END) return null;
  const c = T[lang] || T.en;
  return (
    <section className={compact ? "py-10" : "py-16"} style={{ background: "#0b1220" }}>
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 text-center">{c.head}</h2>
        <div style={{ background: "#111a2e", border: "1px solid #1f2a44", borderRadius: 14, overflow: "hidden" }}>
          <a href={LINK}><img src={IMG} alt={c.name} style={{ width: "100%", height: "auto", display: "block" }} loading="lazy" /></a>
          <div style={{ padding: "22px 24px" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
              <span style={{ background: "#ea580c", color: "#fff", borderRadius: 999, padding: "4px 14px", fontSize: 12, fontWeight: 700 }}>{c.booth}</span>
              <span style={{ background: "#1f2a44", color: "#cbd5e1", borderRadius: 999, padding: "4px 14px", fontSize: 12 }}>{c.date}</span>
              <span style={{ background: "#1f2a44", color: "#cbd5e1", borderRadius: 999, padding: "4px 14px", fontSize: 12 }}>{c.place}</span>
            </div>
            <div style={{ fontSize: 20, fontWeight: 700, color: "#fff" }}>{c.name}</div>
            <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 10 }}>{c.tag}</div>
            <p style={{ fontSize: 15, lineHeight: 1.75, color: "#d1d5db", marginBottom: 18 }}>{c.blurb}</p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
              <a href={BOOK} target="_blank" rel="noopener noreferrer" style={{ background: "#ea580c", color: "#fff", fontWeight: 700, padding: "12px 24px", borderRadius: 8, textDecoration: "none", fontSize: 15 }}>{c.book}</a>
              <a href={LINK} style={{ color: "#fdba74", fontWeight: 600, padding: "12px 20px", borderRadius: 8, textDecoration: "none", fontSize: 15, border: "1px solid #fdba74" }}>{c.read}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
